import { render, staticRenderFns } from "./tab-secondary.vue?vue&type=template&id=3b8ff87d&scoped=true&"
import script from "./tab-secondary.vue?vue&type=script&lang=js&"
export * from "./tab-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8ff87d",
  null
  
)

export default component.exports